// AudioWorklet processor, shipped as source text and loaded via a
// Blob URL so no separate asset pipeline is needed. Downsamples the
// mixed context-rate signal to 16 kHz mono Float32 frames posted to
// the main thread. Design: docs/design-docs/audio-capture.md

export const DOWNSAMPLER_NAME = "mm-downsampler";

const PROCESSOR_SOURCE = `
class MmDownsampler extends AudioWorkletProcessor {
  constructor() {
    super();
    this.target = 16000;
    this.ratio = sampleRate / this.target; // e.g. 48000/16000 = 3
    this.acc = 0;      // fractional read position
    this.carry = [];   // leftover input between process() calls
    this.out = [];
    this.OUT_FRAME = 2048; // ~128ms per post at 16k
  }

  process(inputs) {
    const ch = inputs[0];
    if (!ch || ch.length === 0) return true;
    // Average channels to mono.
    const n = ch[0].length;
    const mono = new Float32Array(n);
    for (let c = 0; c < ch.length; c++) {
      const data = ch[c];
      for (let i = 0; i < n; i++) mono[i] += data[i] / ch.length;
    }
    // Append to carry, then average-pool groups of 'ratio' samples.
    const buf = new Float32Array(this.carry.length + n);
    buf.set(this.carry, 0);
    buf.set(mono, this.carry.length);
    let pos = 0;
    while (pos + this.ratio <= buf.length) {
      const end = pos + this.ratio;
      let sum = 0;
      let count = 0;
      for (let i = Math.floor(pos); i < end; i++) { sum += buf[i]; count++; }
      this.out.push(sum / count);
      pos = end;
    }
    this.carry = buf.slice(Math.floor(pos));
    // Ship fixed-size frames with a transferred buffer.
    while (this.out.length >= this.OUT_FRAME) {
      const frame = new Float32Array(this.out.splice(0, this.OUT_FRAME));
      this.port.postMessage(frame, [frame.buffer]);
    }
    return true;
  }
}
registerProcessor("${DOWNSAMPLER_NAME}", MmDownsampler);
`;

export async function loadDownsampler(ctx: AudioContext): Promise<void> {
  const blob = new Blob([PROCESSOR_SOURCE], { type: "application/javascript" });
  const url = URL.createObjectURL(blob);
  try {
    await ctx.audioWorklet.addModule(url);
  } finally {
    URL.revokeObjectURL(url);
  }
}
